import React, { Component } from "react";
import Container from "../../../../modules/commons/Container";
import InventoryContent from "./common/inventoryContent";

class ReceivingKSU extends Component {
  render() {
    return (
      <Container>
        <InventoryContent tab="ksu" {...this.props}/>
      </Container>
    );
  }
}

export default ReceivingKSU;
